class ProductPrice extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.compare_price = this.querySelector(".product-price--compare");
    this.price = this.querySelector(".product-price--original");
    this.discountContainer = this.querySelector(".discount-container");
    this.discountedPrice = this.querySelector(".discounted-price");
    this.reference_unit = this.querySelector(".product-price--reference-unit");
    this.reference_value = this.querySelector(".product-price--reference-value");
    this.unit_price = this.querySelector(".product-price--unit-price");
    this.unit_price_container = this.querySelector(".product-price--unit-container");
    
    this.discountPercentage = parseFloat(this.dataset.discountPercentage) || 0;
    
    this.updatePriceListener();
  }
  
  disconnectedCallback() {
    window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`);
  }
  
  updatePriceListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged.ProductPrice`,
      ({ detail: { variant: e } }) => {
        this.updatePrices(e);
      }
    );
  }
  
  updatePrices(e) {
    if (e) {
      this.removeAttribute("style");
      
      // Update original price
      this.price.innerHTML = theme.utils.formatMoney(e.price);
      
      // Apply discount if available
      if (this.discountPercentage > 0) {
        const discountAmount = e.price * (this.discountPercentage / 100);
        const customPrice = Math.round(e.price - discountAmount);
        
        // Make sure the original price is visible and styled as crossed out
        this.price.style.display = "block";
        this.price.style.textDecoration = "line-through";
        
        // Update the discounted price
        if (this.discountedPrice) {
          this.discountedPrice.innerHTML = theme.utils.formatMoney(customPrice);
        }
        
        // Make sure discount container is visible
        if (this.discountContainer) {
          this.discountContainer.style.display = "flex";
        }
      } else {
        // No discount applied
        this.price.style.textDecoration = "none";
        
        // Hide discount container if it exists
        if (this.discountContainer) {
          this.discountContainer.style.display = "none";
        }
      }
      
      // Update compare at price (if it exists and is higher than current price)
      if (this.compare_price) {
        if (e.compare_at_price > e.price) {
          this.compare_price.innerHTML = theme.utils.formatMoney(e.compare_at_price);
          this.compare_price.style.display = "inline-block";
        } else {
          this.compare_price.style.display = "none";
        }
      }
      
      // Update unit price if available
      if (e.unit_price_measurement) {
        this.unit_price.innerHTML = theme.utils.formatMoney(e.unit_price);
        this.reference_unit.innerHTML = e.unit_price_measurement.reference_unit;
        
        if (this.reference_value) {
          if (e.unit_price_measurement.reference_value === 1) {
            this.reference_value.style.display = "none";
          } else {
            this.reference_value.innerHTML = e.unit_price_measurement.reference_value;
            this.reference_value.style.display = "block";
          }
        }
        
        this.unit_price_container.style.display = "flex";
      } else if (this.unit_price_container) {
        this.unit_price_container.style.display = "none";
      }
    } else {
      this.style.display = "none";
    }
  }
}

const productPriceEl = customElements.get("product-price-root");
productPriceEl || customElements.define("product-price-root", ProductPrice);